import React from 'react';
import { StyledHeaderDirectory, StyledHeaderItem } from './style';

const HeaderData = [
  'Nombre',
  'Apellidos',
  'DNI',
  'Email',
  'Fecha',
  'Motivo',
  'Año Certificado',
  'Enviado'
];

const HeaderDirectoryWithholding = () => (
  <StyledHeaderDirectory>
    {HeaderData.map((item, i) => (
      <StyledHeaderItem key={`header-g-${i + 1}`}>{item}</StyledHeaderItem>
    ))}
    <StyledHeaderItem />
  </StyledHeaderDirectory>
);

export default HeaderDirectoryWithholding;
